import { createReducer, on } from "@ngrx/store"
import * as customerActions from './customers.actions';

export interface CustomerState {
    serviceTypes: [] | null
    serviceTypesError: boolean
    serviceTypesLoading: boolean

    customerTypes: [] | null
    customerTypesError: boolean
    customerTypesLoading: boolean

    customers: [] | null
    customersError: boolean
    customersLoading: boolean
}

export const initialState: CustomerState = {

    serviceTypes: null,
    serviceTypesError: null,
    serviceTypesLoading: null,

    customerTypes: null,
    customerTypesError: null,
    customerTypesLoading: null,

    customers: null,
    customersError: null,
    customersLoading: null,

}

export const CustomersReducer = createReducer(
    initialState,


    on(customerActions.fetchServiceTypes, (state) => ({
        ...state, serviceTypes: null, serviceTypesError: null, serviceTypesLoading: true
    })),

    on(customerActions.fetchServiceTypesSuccess, (state, {serviceTypes}) => ({
        ...state, serviceTypes: serviceTypes, serviceTypesError: false, serviceTypesLoading: false
    })),

    on(customerActions.fetchServiceTypesFailed, (state) => ({
        ...state, serviceTypes: null, serviceTypesError: true, serviceTypesLoading: false
    })),


    on(customerActions.fetchCustomerTypes, (state) => ({
        ...state, customerTypes: null, customerTypesError: null, customerTypesLoading: true
    })),

    on(customerActions.fetchCustomerTypesSuccess, (state, {customerTypes}) => ({
        ...state, customerTypes: customerTypes, customerTypesError: false, customerTypesLoading: false
    })),

    on(customerActions.fetchCustomerTypesFailed, (state) => ({
        ...state, customerTypes: null, customerTypesError: true, customerTypesLoading: false
    })),



    on(customerActions.fetchCustomers, (state) => ({
        ...state, customers: null, customersError: null, customersLoading: true
    })),

    on(customerActions.fetchCustomersSuccess, (state, {customers}) => ({
        ...state, customers: customers, customersError: false, customersLoading: false
    })),

    on(customerActions.fetchCustomersFailed, (state) => ({
        ...state, customers: null, customersError: true, customersLoading: false
    })),


)